import { render, staticRenderFns } from "./pposition.vue?vue&type=template&id=9d1cf68e&scoped=true&"
import script from "./pposition.vue?vue&type=script&lang=js&"
export * from "./pposition.vue?vue&type=script&lang=js&"
import style0 from "./pposition.vue?vue&type=style&index=0&id=9d1cf68e&lang=scss&scoped=true&"
import style1 from "./pposition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1cf68e",
  null
  
)

export default component.exports